import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { faBoxesStacked, faChartLine, faFileArchive, faShieldHalved, faUsers, faWallet } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "../InfoIcon";
import useFetch from "../../hook/useFetch";
import useHeaderRefresh from "../../hook/useHeaderRefresh";
import useRole from "../../hook/useRole";

const asArray = value => Array.isArray(value) ? value : value ? Object.values(value) : [];
const StatCard = ({ icon, label, value, hint, tone }) => <article className={`overview-stat overview-stat-${tone}`}><span className="overview-stat-icon"><InfoIcon icon={icon} /></span><div><strong>{value ?? "–"}</strong><span>{label}</span><small>{hint}</small></div></article>;
const QuickLink = ({ to, title, text }) => <Link className="overview-link" to={to}><strong>{title}</strong><span>{text}</span><b>Open →</b></Link>;

export default function AdminDashboard() {
  const user = useSelector(state => state.user.user);
  const { get, error } = useFetch();
  const { hasrole: isSuperUser } = useRole("rsosuperuser");
  const [stats, setStats] = useState({ users: null, products: null, files: null, refunds: null });

  const loadStats = () => {
    const setCount = key => data => setStats(current => ({ ...current, [key]: asArray(data).length }));
    get("/admin/users", null, null, setCount("users"));
    get("/admin/products", null, null, setCount("products"));
    get("/admin/files", null, null, setCount("files"));
    get("/admin/payment/rollback-requests", null, null, setCount("refunds"));
  };
  useEffect(() => { loadStats(); }, []);
  useHeaderRefresh(loadStats);

  return <div className="overview-dashboard">
    <section className="overview-hero overview-hero-admin"><div><span className="overview-eyebrow">ADMIN CONTROL CENTER</span><h1>Welcome back, {user?.username || "Admin"}.</h1><p>Users, content, and system tools at a glance.</p></div><div className="overview-security"><InfoIcon icon={faShieldHalved} size="2xl" /><span>Admin access</span><strong>2FA protected</strong></div></section>
    {error && <div className="alert alert-danger">Some metrics could not be loaded: {String(error)}</div>}
    <section className="overview-stats" aria-label="Dashboard metrics">
      <StatCard icon={faUsers} label="Users" value={stats.users} hint="Manage accounts" tone="blue" />
      <StatCard icon={faBoxesStacked} label="Products" value={stats.products} hint="In product catalog" tone="violet" />
      <StatCard icon={faFileArchive} label="Files" value={stats.files} hint="In upload storage" tone="cyan" />
      <StatCard icon={faWallet} label="Refunds" value={stats.refunds} hint="Open requests" tone={stats.refunds ? "orange" : "green"} />
    </section>
    <section className="overview-panel"><div className="overview-heading"><div><span className="overview-eyebrow">QUICK ACCESS</span><h2>What would you like to work on?</h2></div><InfoIcon icon={faChartLine} size="2xl" /></div><div className="overview-links">
      <QuickLink to="/admin/users" title="Users & Rechte" text="Manage accounts, admin permissions, and 2FA approvals." />
      <QuickLink to="/admin/products" title="Products" text="Review, edit, or create products." />
      <QuickLink to="/admin/uploadmanagement" title="Uploadmanagement" text="Upload files and manage metadata." />
      {isSuperUser && <QuickLink to="/admin/pdc" title="PDC Analytics" text="Analyze views, devices, countries, and sources." />}
      {isSuperUser && <QuickLink to="/admin/invoices" title="Rechnungen" text="Rechnungen erstellen, verwalten und als PDF öffnen." />}
      {isSuperUser && <QuickLink to="/admin/timesheets" title="Zeitnachweise" text="Arbeitszeiten und Leistungen erfassen, berechnen und als PDF öffnen." />}
      <QuickLink to="/admin/instagram" title="Instagram" text="Compare and analyze follower exports." />
    </div></section>
  </div>;
}
